export default "__VITE_ASSET__C3FNqxxC__"